import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ name: 'collapseDirection' })
export class CollapseDirectionPipe implements PipeTransform {
  transform(direction: string) {
    return `off-canvas-collapse__${direction}`;
  }
}
